<template>
  <b-card :class="`dashboard-csr-initiative${isDashboard ? '__dashboard' : ''}`" body-class="pb-0">
    <b-card-header class="d-none d-md-block pt-0 ">
      <b-row>
        <b-col class="px-0 d-flex justify-content-start align-items-center">
          <span class="headline-icon mr-2">{{ csrInitiative.icon }}</span>
          <span class="headline ml-1" style="line-height: 22px">{{ csrInitiative.headline }}</span>
        </b-col>
      </b-row>
    </b-card-header>

    <b-card-body class="p-0">
      <b-row>
        <b-col v-if="monthlyUnit">
          <div v-if="!isCampaign" class="section-title mt-2">This month</div>
          <div class="w-100 mb-2 mt-2 d-flex justify-content-between align-items-center">
            <div class="point-box">
              <div v-if="isPreview" class="point float-left mr-2">{{ randomNumber }}</div>
              <div v-else class="point float-left mr-2">{{ monthlyProgress }}</div>
              <div class="label-box float-left mr-2">
                <strong>{{ monthlyUnit.display ? monthlyUnit.display.firstLine : ' - ' }}</strong><br/>
                <span class="small">{{ monthlyUnit.display ? monthlyUnit.display.secondLine : '' }}</span>
              </div>
            </div>
            <div style="max-width: 180px; font-size: 13px" v-html="monthlyGoalText"></div>
          </div>
          <b-progress
            v-if="isPreview"
            :class="isDashboard ? 'mb-2' : 'mb-3'"
            :value="randomNumber"
            :max="345"
          />
          <b-progress
            v-else
            :class="isDashboard ? 'mb-2' : 'mb-3'"
            :value="monthlyProgress"
            :max="monthlyUnit && monthlyUnit.monthlyGoal ? monthlyUnit.monthlyGoal.totalSum : 0"
          />

          <hr v-if="showWholeYearTotal && !hideYear" :class="isDashboard ? 'my-2' : 'my-3'" />

          <div v-if="showWholeYearTotal && !hideYear && !isCampaign" :class="isDashboard ? 'section-title mt-2' : 'section-title mt-3'">
            <span>So far...</span>
            <b-row class="mt-2 mb-3">
              <b-col v-for="unit in (Array.isArray(csrInitiative.units) ? csrInitiative.units : [])" :key="unit.name" cols="6">
                <div class="point-box">
                  <div v-if="isPreview" class="point float-left mr-2">{{ Math.floor(randomNumber * 1.2) }}</div>
                  <div v-else class="point float-left mr-2">{{ overallProgress(unit) }}</div>
                  <div class="label-box float-left mr-2">
                    <strong>{{ unit.display ? unit.display.firstLine : ' - ' }}</strong><br/>
                    <span class="small">{{ unit.display ? unit.display.secondLine : '' }}</span>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-footer class="text-center">
      <b-link v-b-modal="`csr-details-${csrInitiative.headline}`">
        Learn More
      </b-link>
    </b-card-footer>

    <b-modal :id="`csr-details-${csrInitiative.headline}`" title="Our Initiative" hide-footer>
      <div v-html="csrInitiative.description"></div>
    </b-modal>

  </b-card>
</template>

<script>
import LeaderboardDetailsModal from '@/modals/leaderboard-details-modal';
import { formatDate } from '@src/filters';

export default {
  props: {
    monthlyTotalPoints: {
      type: Number
    },
    leaderboardMonthlyPoints: {
      type: Array
    },
    hideYear: {
      type: Boolean
    },
    isPreview: {
      type: Boolean
    },
    isCampaign: {
      type: Boolean
    },
    isDashboard: {
      type: Boolean
    },
    csrInitiative: {
      type: Object,
      default: () => ({
        headline: 'Every action on this platform helps us make our planet greener!',
        icon: '🌿',
        description: `<p>For every job you share with your network and referral you make we will plant a tree to help the Yucatan Restoration project.</p>
        <p>Our target is to plant 345 trees per month and you can help simply by sharing and referring.</p>
        <p>Read more about the details here: <a href="https://www1.plant-for-the-planet.org/yucatan" rel="external" target="_blank">Plant For The Planet</a></p>`,
        units: [
          {
            icon: '🌳',
            conversion: 1,
            name: 'Tree',
            monthlyGoal: {
              totalSum: 345,
              text: 'Help us reach our goal to plant {totalSum} trees this month.'
            },
            display: {
              firstLine: 'Trees',
              secondLine: 'Planted',
            },
            cap: 345,
            showWholeYearTotal: true,
          },
          {
            conversion: 0.021,
            decimals: 2,
            name: 'Co2',
            display: {
              firstLine: 'Tons of CO2',
              secondLine: 'Removed',
            },
            cap: 345 * 0.021,
            showWholeYearTotal: true,
          },
        ]
      }),
    },
  },
  components: {
    LeaderboardDetailsModal,
  },
  watch: {
    csrInitiative() {
      console.log({ 'csr initiative': this.csrInitiative });
    }
  },
  computed: {
    showWholeYearTotal() {
      return this.csrInitiative.units.reduce((out, { showWholeYearTotal }) => showWholeYearTotal || out, false);
    },
    monthlyUnit() {
      const { csrInitiative } = this;
      const { units } = csrInitiative || {};
      return (Array.isArray(units) ? units : []).find(({ monthlyGoal }) => !!monthlyGoal);
    },
    monthlyProgress() {
      const { monthlyUnit, monthlyTotalPoints, convertValue } = this;
      if (!monthlyUnit) return 0;
      const { conversion, decimals, monthlyGoal } = monthlyUnit;
      const { totalSum } = monthlyGoal || {};
      return convertValue(monthlyTotalPoints, conversion, decimals, totalSum);
    },
    monthlyGoalText() {
      const { monthlyGoal } = this.monthlyUnit || {};
      const { text, totalSum } = monthlyGoal || {};
      return text ? text.replace('{totalSum}', `<strong>${totalSum || ''}</strong>`) : '';
    },
    randomNumber() {
      return Math.floor(Math.random() * 150 + 50);
    }
  },
  methods: {
    formatDate,
    overallProgress(unit) {
      const { convertValue } = this;
      const { conversion, decimals, monthlyGoal } = unit;
      const { totalSum } = monthlyGoal || {};
      return this.leaderboardMonthlyPoints.reduce((sum, points) => {
        let val = convertValue(points, conversion, decimals, totalSum);
        if (typeof val === 'string') {
          val = parseFloat(val);
        }
        console.log({ val });
        return sum += val;
      }, 0);
    },
    convertValue(points, conversion, decimals, cap) {
      if (typeof points === 'number') {
        let value = points * (conversion || 1);
        if (cap && typeof cap === 'number') {
          value = value > cap ? cap : value;
        }
        if (decimals) {
          value = value.toFixed(decimals);
        } else {
          value = Math.round(value);
        }
        return value;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
.dashboard-csr-initiative {
  .card-header {
    background: white;
    .headline {
      font-weight: bold;
    }
    .headline-icon {
      font-size: 24px;
    }
  }
  .card-body {
    .section-title {
      font-weight: bold;
      font-size: 16px;
    }

    .point-box {
      overflow: hidden;
      .point {
        font-weight: bold;
        font-size: 30px;
        line-height: 30px;
      }
      .label-box {
        line-height: 15px;
        .small {
          font-size: 13px;
        }
      }
    }

  }
  .card-footer {
    background-color: inherit;
  }
}
.dashboard-csr-initiative__dashboard {
  .card-header {
    background: white;
    .headline {
      font-weight: bold;
    }
    .headline-icon {
      font-size: 20px;
    }
  }
  .card-body {
    .section-title {
      font-weight: bold;
      font-size: 14px;
    }

    .point-box {
      overflow: hidden;
      .point {
        font-weight: bold;
        font-size: 24px;
        line-height: 24px;
      }
      .label-box {
        line-height: 13px;
        .small {
          font-size: 11px;
        }
      }
    }

  }
  .card-footer {
    background-color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/CsrInitiative.vue